import { render, staticRenderFns } from "./ModalXLTJ_Charge.vue?vue&type=template&id=0dfd5440&scoped=true&"
import script from "./ModalXLTJ_Charge.vue?vue&type=script&lang=js&"
export * from "./ModalXLTJ_Charge.vue?vue&type=script&lang=js&"
import style0 from "./ModalXLTJ_Charge.vue?vue&type=style&index=0&id=0dfd5440&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfd5440",
  null
  
)

export default component.exports